import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZAssetRecord = z.object({
  id: z.string(),
  name: z.string(),
  serial_number: z.string(),
  install_date: z.string(),
  asset_type_id: z.string(),
  asset_type_name: z.string(),
  timezone: z.string(),
  application_type: z.string(),
  description: z.string()
})

const ZAssetsBySubscriptionData = z.object({
  total_count: z.number(),
  assets: z.array(ZAssetRecord)
})

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZAssetsBySubscriptionData,
  error: z.boolean()
})

export type GetAssetsBySubscriptionApiResponse = z.infer<typeof ZAssetRecord>
export type GetAssetsBySubscriptionData = z.infer<typeof ZAssetsBySubscriptionData>

export async function getAssetsBySubscription (
  page: number,
  size: number,
  sortBy: string,
  sortDirection: 'asc' | 'desc',
  search: string | undefined,
  onSuccess: (successResponse: GetAssetsBySubscriptionData, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/assets/asset-management/by-sub-id'

  const params: Record<string, string | number> = {
    page: page - 1,
    size,
    sortBy,
    sortDirection
  }

  const trimmedSearch = search?.trim()
  if (trimmedSearch !== undefined && trimmedSearch !== '') {
    params.search = trimmedSearch
  }

  interceptedAxios
    .get(url, {
      params,
      timeout: 15000
    })
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)

      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message ?? error.response.data.message ?? 'Request failed', error.response.data.http_status ?? error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
